export class ScheduleAiJobResponse {
  constructor(
    public jobUid: string,
    public responseMsg: string,
    public isSuccess: boolean,
  ) {}
}
